import { useMemo } from 'react';

import { Log } from '@common/log-manager';
import { useInitLikedProducts } from '@widgets/like-product';

import { StoreHomeVerticalProductCardList } from '../components/vertical-product-card-list';
import { ShopUxProductCardItem } from '../graphql/index_types.2';
import { useEnvConfig } from '../hooks/useEnvConfig';
import { ComponentProps } from '../types/component';
import { convertProductItemListToUxGoodsCardItemList, convertProductListToIdList } from '../utils/product';

interface ProductListProps extends ComponentProps<ShopUxProductCardItem[]> {
  log?: Partial<Log>;
  use_impression?: boolean;
  columnCount?: 2 | 3;
}

export const ProductList = ({ component, log, use_impression, columnCount }: ProductListProps) => {
  const { is_zigzag } = useEnvConfig();
  const products = useMemo(
    () => convertProductItemListToUxGoodsCardItemList({ item_list: component, is_zigzag, show_ranking: false }),
    [component, is_zigzag],
  );
  useInitLikedProducts({
    data: products,
    convert: convertProductListToIdList,
  });

  if (products instanceof Array === false || products.length === 0) {
    return null;
  }

  return (
    <StoreHomeVerticalProductCardList
      item_list={products}
      log={log}
      useImpression={use_impression}
      columnCount={columnCount}
    />
  );
};
